import React from 'react';
export function AboutSection() {
  return <section id="about" className="relative bg-[#1a1a1a] py-32 md:py-40 px-4" data-id="element-24">
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#1a1a1a] to-transparent pointer-events-none" data-id="element-25" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-26">
        <div className="mb-24" data-id="element-27">
          <p className="text-lg font-bold uppercase tracking-widest text-[#1e3a5f] mb-4" data-id="element-28">
            About Us
          </p>
        </div>

        <div className="space-y-16" data-id="element-29">
          <p className="text-2xl md:text-3xl text-gray-400 font-light" data-id="element-30">
            Pimlico Trading is a company with energy, curiosity and ambition.
          </p>

          <p className="text-3xl md:text-5xl text-[#fafafa] font-semibold leading-tight" data-id="element-31">
            We are building a category-defining player to change the shape of
            global distribution forever.
          </p>

          <div className="max-w-2xl mx-auto pt-8" data-id="element-32">
            <p className="text-lg text-gray-500 leading-relaxed" data-id="element-33">
              We look for incredibly talented and enthusiastic individuals who
              want to spend the next five+ years of their careers working with
              relentless focus to build something meaningful. A good week for us
              is one in which we have learnt something new and built something
              new.
            </p>
            <a href="/careers" className="inline-block mt-8 text-[#b8d4e8] border-b border-[#b8d4e8] pb-1 hover:text-white hover:border-white transition-colors" data-id="element-34">
              Join our team
            </a>
          </div>
        </div>
      </div>
    </section>;
}